import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SEARCH_TYPE } from '../constants';
import './SearchBar.css';

import {parseUrlParam, parseQueryParam} from '../utils';
import { fetchAlbums, loading, updateAlbumIndex } from '../actions/index';

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = { term: ''};
  }

  onInputChange = (event) => {
    this.setState({ term: event.target.value });
  }

  onFormSubmit = (event) => {
    event.preventDefault();
    this.props.fetchAlbums(this.state.term);
    this.props.updateAlbumIndex(null);
    this.props.loading(SEARCH_TYPE.ARTIST);
  }

 preloadArtist = (searchTerm) => {
   const sanitisedSearchTerm = searchTerm.replace(/%20/gi, ' ').trim();
   this.props.fetchAlbums(sanitisedSearchTerm);
   this.setState({term: sanitisedSearchTerm});
   this.props.loading(SEARCH_TYPE.ARTIST);
 }

  componentDidMount() {
    const url = window.location.href;
    if(url.includes('/artist/')) {
      this.preloadArtist(parseUrlParam('artist', url))
    }
    else if(url.includes('artist=')) {
      this.preloadArtist(parseQueryParam('artist', url))
    }
  }

  render() {
    return (
    <form className="search wrapper" onSubmit={this.onFormSubmit}>
      <div className="input-field">
        <input
          className="search-bar"
          type="text"
          placeholder="Search Artist Here"
          value={this.state.term}
          onChange={this.onInputChange}
        />
      </div>
    </form>
    );
  }

}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ fetchAlbums, loading, updateAlbumIndex }, dispatch);
}

export default connect(null, mapDispatchToProps)(SearchBar);



// WEBPACK FOOTER //
// ./src/containers/SearchBar.js